module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/th/4/1-65a95d5ddb65e365179a3ed8b195748f.jpg";